//Import required libraies
import React from "react";

//Import Custom Component
import LocalParameterItem from "./LocalParameterItem";

function GroupAllTargets(props) {
  let { id, name, value, onChange } = props;

  return (
    <div>
      <LocalParameterItem
        value={value}
        name={name}
        ui_element_type="checkbox"
        onChange={onChange}
        id={id}
      />
    </div>
  );
}

export default GroupAllTargets;
